import { Form, FormInstance, Select } from 'antd';
import IconDown from 'assets/icons/chevron-down.svg';
import { useEffect, useState } from 'react';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { AuctionBidsPrice } from '../../CU-014-02/models/AuctionBids';

const { Option } = Select;

interface props {
    form: FormInstance<any>;
    valueSelect: string;
    onChangeSelect: (value: string) => void;
    selectData?: AuctionBidsPrice;
}

const SelectComponent = ({ form, valueSelect, onChangeSelect, selectData }: props) => {
    const [selectOptions, setSelectOptions] = useState<any[]>([]);

    useEffect(() => {
        const lowerLimit = selectData?.priceLowerLimit
            ? commonHelpers.roundTenThousandYen(selectData?.priceLowerLimit)
            : 0;
        const upperLimit = selectData?.priceUpperLimit
            ? commonHelpers.roundTenThousandYen(selectData?.priceUpperLimit)
            : 0;
        if (lowerLimit && upperLimit) {
            const options = [];
            for (let i = lowerLimit; i <= upperLimit; i += 10) {
                options.push({
                    name: `${i.toLocaleString()}万円`,
                    value: i * 10000,
                });
            }
            setSelectOptions(options);
        }
    }, [selectData]);

    return (
        <div
            style={{
                width: '100%',
                height: '108px',
                borderBottom: '1px white solid',
            }}
        >
            <div className="text-label-select">入札額</div>

            <Form form={form} id="form-select">
                <Form.Item name="bidAmount">
                    <Select
                        placeholder={PLACEHOLDER.SELECT}
                        style={{
                            width: '100%',
                        }}
                        size="large"
                        suffixIcon={<img src={IconDown} />}
                        value={valueSelect}
                        onChange={(value: string) => onChangeSelect(value)}
                    >
                        {selectOptions.map((state: any) => {
                            return (
                                <Option
                                    style={{ color: '#28323C' }}
                                    key={state.name}
                                    value={state.value}
                                >
                                    {state.name}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>
            </Form>
        </div>
    );
};

export default SelectComponent;
